export const isProduction = ["local", "production"].includes(
  process.env.GATSBY_ACTIVE_ENV
);
